import { render, staticRenderFns } from "./CenteredActiveItem.vue?vue&type=template&id=4aa8550c&"
import script from "./CenteredActiveItem.vue?vue&type=script&lang=js&"
export * from "./CenteredActiveItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports